import { jsx } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import useFormField from "./useFormField.mjs";
import { useThemeProps, Typography } from "@wsui/base";
function FormFieldError(props) {
  props = useThemeProps({
    props,
    name: "FormFieldError"
  });
  let {
    as: Component = "div",
    color = "error.600",
    ...restProps
  } = props;
  const {
    meta,
    id
  } = useFormField();
  return /* @__PURE__ */jsx(Component, {
    id: `${id}-errors`,
    "aria-live": "assertive",
    css: /* @__PURE__ */css("position:", meta.error && meta.touched ? null : "absolute", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FormFieldError;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9qZWFuZnJlZHJpay9wcm9qZWN0cy93c3VpL3BhY2thZ2VzL2Zvcm0vc3JjL0Zvcm1GaWVsZEVycm9yLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjYyIsImZpbGUiOiIvVXNlcnMvamVhbmZyZWRyaWsvcHJvamVjdHMvd3N1aS9wYWNrYWdlcy9mb3JtL3NyYy9Gb3JtRmllbGRFcnJvci5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcbmltcG9ydCB1c2VGb3JtRmllbGQgZnJvbSBcIi4vdXNlRm9ybUZpZWxkXCI7XG5pbXBvcnQgeyBUeXBvZ3JhcGh5LCB1c2VUaGVtZVByb3BzIH0gZnJvbSBcIkB3c3VpL2Jhc2VcIjtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRm9ybUZpZWxkRXJyb3IocHJvcHMpIHtcbiAgcHJvcHMgPSB1c2VUaGVtZVByb3BzKHsgcHJvcHMsIG5hbWU6IFwiRm9ybUZpZWxkRXJyb3JcIiB9KTtcbiAgbGV0IHsgYXM6IENvbXBvbmVudCA9IFwiZGl2XCIsIGNvbG9yID0gXCJlcnJvci42MDBcIiwgLi4ucmVzdFByb3BzIH0gPSBwcm9wcztcblxuICBjb25zdCB7IG1ldGEsIGlkIH0gPSB1c2VGb3JtRmllbGQoKTtcblxuICByZXR1cm4gKFxuICAgIDxDb21wb25lbnRcbiAgICAgIGlkPXtgJHtpZH0tZXJyb3JzYH1cbiAgICAgIGFyaWEtbGl2ZT1cImFzc2VydGl2ZVwiXG4gICAgICBjc3M9e2Nzc2BcbiAgICAgICAgcG9zaXRpb246ICR7bWV0YS5lcnJvciAmJiBtZXRhLnRvdWNoZWQgPyBudWxsIDogXCJhYnNvbHV0ZVwifTtcbiAgICAgIGB9XG4gICAgICB7Li4ucmVzdFByb3BzfVxuICAgID5cbiAgICAgIHttZXRhLmVycm9yICYmIG1ldGEudG91Y2hlZCAmJiAoXG4gICAgICAgIDxUeXBvZ3JhcGh5IHZhcmlhbnQ9XCJkZXNjcmlwdGlvblwiIGNvbG9yPXtjb2xvcn0+XG4gICAgICAgICAge21ldGEuZXJyb3J9XG4gICAgICAgIDwvVHlwb2dyYXBoeT5cbiAgICAgICl9XG4gICAgPC9Db21wb25lbnQ+XG4gICk7XG59XG4iXX0= */"),
    ...restProps,
    children: meta.error && meta.touched && /* @__PURE__ */jsx(Typography, {
      variant: "description",
      color,
      children: meta.error
    })
  });
}
export { FormFieldError as default };